import React from 'react';

interface StoryIconProps {
    isActive: boolean;
    size?: number;
    color?: string;
}

export const StoryIcon: React.FC<StoryIconProps> = ({ isActive, size = 16, color }) => {
    const activeColor = color || "var(--color-accent-success)";

    if (isActive) {
        // Active story: Pulsing recording dot with story lines
        return (
            <svg
                width={size}
                height={size}
                viewBox="0 0 24 24"
                fill="none"
                style={{ display: 'inline-block', verticalAlign: 'middle', marginRight: '6px' }}
            >
                {/* Strong Pulse Effect */}
                <circle
                    cx="12" cy="12"
                    r="8"
                    fill={activeColor}
                >
                    <animate
                        attributeName="r"
                        values="6;10;6"
                        dur="1s"
                        repeatCount="indefinite"
                    />
                    <animate
                        attributeName="opacity"
                        values="0.8;0.2;0.8"
                        dur="1s"
                        repeatCount="indefinite"
                    />
                </circle>

                {/* Solid Core */}
                <circle cx="12" cy="12" r="5" fill={activeColor} />
                <circle cx="12" cy="12" r="2" fill="#fff" />
            </svg>
        );
    }

    // Completed story: Stacked pages/story icon
    const baseColor = color || "var(--color-text-muted)";
    const strokeCol = color || "var(--color-text-secondary)";

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            style={{ display: 'inline-block', verticalAlign: 'middle', marginRight: '6px' }}
        >
            {/* Back page */}
            <rect
                x="5" y="2"
                width="14" height="18"
                rx="2"
                fill={baseColor}
                opacity={color ? "0.6" : "0.3"} /* increased opacity if colored */
            />
            {/* Middle page */}
            <rect
                x="4" y="3"
                width="14" height="18"
                rx="2"
                fill={baseColor}
                opacity={color ? "0.8" : "0.5"} /* increased opacity if colored */
            />
            {/* Front page */}
            <rect
                x="3" y="4"
                width="14" height="18"
                rx="2"
                fill="var(--color-panel-border)"
                stroke={color || "var(--color-text-secondary)"}
                strokeWidth={color ? "1" : "0.5"} /* thicker stroke if colored */
            />
            {/* Content lines */}
            <line x1="6" y1="9" x2="14" y2="9" stroke={baseColor} strokeWidth="1.5" strokeLinecap="round" />
            <line x1="6" y1="13" x2="12" y2="13" stroke={baseColor} strokeWidth="1.5" strokeLinecap="round" />
            <line x1="6" y1="17" x2="10" y2="17" stroke={baseColor} strokeWidth="1.5" strokeLinecap="round" />
        </svg>
    );
};
